export const provideStringValueIfNullable = (value: string | null | undefined) => value || '';
